<template>
  <div class="navbar flex flex-x-between flex-y-center">
    <div class="name text-decoration">Tieyong Zeng</div>
    <el-menu
      v-if="isPc"
      :default-active="activePath"
      class="menu-list"
      mode="horizontal"
      router
    >
      <el-menu-item
        v-for="item in menuData"
        :key="item.key"
        :index="item.path"
      >
        {{ item.name }}
      </el-menu-item>
    </el-menu>
    <el-dropdown v-else trigger="click" @command="handleCommand">
      <span class="el-dropdown-link">
        <i class="el-icon-arrow-down el-icon-s-fold" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in menuData"
          :key="item.key"
          :command="item.path"
          :divided="index !== 0"
        >
          <p class="fs-20 drop-menu__item" :class="{'active-path': activePath === item.path}">{{ item.name }}</p>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: { },
  data() {
    return {
      url: require('@/assets/logo.png'),
      menuData: [
        { key: 'home', name: 'Home', path: '/home' },
        { key: 'awards', name: 'Awards & Grants', path: '/awards' },
        { key: 'publications', name: 'Publications', path: '/publications' },
        { key: 'teaching', name: 'Teaching', path: '/teaching' },
        { key: 'activities', name: 'Activities', path: '/activities' },
        { key: 'about', name: 'About me', path: '/about' }
      ]
    }
  },
  computed: {
    ...mapGetters(['device']),
    isPc() {
      return this.device === 'pc'
    },
    activePath() {
      return this.$route.path
    }
  },
  created() {},
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    handleCommand(path) {
      if (path !== this.activePath) {
        this.$router.push({ path })
      }
    },
    goHome() {
      if (this.activePath === '/home/index') return
      this.$router.push({ path: '/home/index' })
    }
  }
}
</script>

<style lang="scss">
.drop-menu__item{
  padding: 10px;
  text-align: center;
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/variables.scss';
.navbar{
  top: 0;
  z-index: 9;
  width: 100vw;
  position: fixed;
  background: #fff;
  padding: 20px 30px 20px 50px;
  border-bottom: 1px solid #e6e6e6;
  // box-shadow: 0 0 30px 0 rgba($color: #000000, $alpha: .1);
  .name{
    height: 38px;
    font-size: 24px;
    margin-top: 10px;
    line-height: 24px;
    font-weight: bold;
    position: relative;
  }
  .active{
    color: $mainColor;
  }
  .menu-list{
    display: flex;
    align-content: center;
    // letter-spacing: 1px;
    border-bottom: none;
    .el-menu-item{
      color: #333;
      height: 38px;
      font-size: 14px;
      line-height: 38px;
      border-radius: 4px;
      font-family: 'Harmony-Rgular';
      // text-transform: uppercase;
      &:hover{
        color: $mainColor;
        border-bottom: 2px solid $mainColor;
      }
    }
    .el-menu-item:focus,
    .is-active, .is-active:hover{
      color: #fff;
      font-weight: bold;
      border-color: $mainColor;
      background-color: $mainColor;
    }
  }
  .el-dropdown-link{
    height: 80px;
    color: $mainColor;
    font-size: 36px;
    padding-right: 20px;
  }
}
.small-navbar{
  .logo-box{
    height: 60px;
    .el-image{
      width: 100px;
      height: 40px;
    }
  }
  .el-dropdown-link{
    height: 60px;
    line-height: 60px;
  }
}
</style>
